module.exports = __webpack_public_path__ + "media/fx-breath.2a7f7e8f.mp3";